import AssetInventoryRoute from './AssetInventoryRoute';
import'./AssetInventory.scss';

const AssetInventory = () =>{
    return <AssetInventoryRoute/>
}
export default AssetInventory